module.exports = __webpack_public_path__ + "static/media/background.19f5122b.svg";